import { ActionContextBasic } from '../index'
import { Case, PhaseCases } from '@/modules/Case/interfaces/case'
import { Case as Newcase, PhaseCases as NewPhaseCases } from '@/modules/Newcase/interfaces/case'

export interface State {
  quoting: Case[],
  proposal: Case[],
  binding: Case[],
  completed: Case[]
  sales: Newcase[]
  service: Newcase[]
}

const state = () => ({
  quoting: [],
  proposal: [],
  binding: [],
  completed: [],
  sales: [],
  service: []
})

const mutations = {
  PUSH_CASES (state: State, phase: PhaseCases) {
    switch (phase.type) {
      case 'quoting':
        state.quoting = [...state.quoting, ...phase.cases]
        break
      case 'proposal':
        state.proposal = [...state.proposal, ...phase.cases]
        break
      case 'binding':
        state.binding = [...state.binding, ...phase.cases]
        break
      case 'completed':
        state.completed = [...state.completed, ...phase.cases]
    }
  },
  UPDATE_CASES (state: State, phase: PhaseCases) {
    switch (phase.type) {
      case 'quoting':
        state.quoting = phase.cases
        break
      case 'proposal':
        state.proposal = phase.cases
        break
      case 'binding':
        state.binding = phase.cases
        break
      case 'completed':
        state.completed = phase.cases
    }
  },
  PUSH_NEWCASES (state: State, phase: NewPhaseCases) {
    switch (phase.type) {
      case 'sales':
        state.sales = [...state.sales, ...phase.cases]
        break
      case 'service':
        state.service = [...state.service, ...phase.cases]
    }
  },
  UPDATE_NEWCASES (state: State, phase: NewPhaseCases) {
    switch (phase.type) {
      case 'sales':
        state.sales = phase.cases
        break
      case 'service':
        state.service = phase.cases
    }
  }
}

const actions = {
  pushCases: (context: ActionContextBasic, phase: PhaseCases) => {
    context.commit('PUSH_CASES', phase)
  },
  updateCases: (context: ActionContextBasic, phase: PhaseCases) => {
    context.commit('UPDATE_CASES', phase)
  },
  pushNewCases: (context: ActionContextBasic, phase: NewPhaseCases) => {
    context.commit('PUSH_NEWCASES', phase)
  },
  updateNewCases: (context: ActionContextBasic, phase: NewPhaseCases) => {
    context.commit('UPDATE_NEWCASES', phase)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
